import { t } from "i18next";
import React, { useEffect, useState } from "react";
import styles from "styles.module.css";
import { UserInformation } from "ui/userprofile/UserInformation";
import { NotificationPage } from "ui/userprofile/Notification";
import { getUserProfileApi, getUserVesselsApi } from "api/user";
import { UserProfile, UserRole } from "interface/user";
import {
	getGetInternationalCountryCodeApi,
	getProductsPagingApi,
} from "api/common";
import { InternationalCountryCode, Product } from "interface/common";
import { IUserProfileVessel } from "interface/vessel";
import { IProduct } from "interface/product";
import { ChangeRegistration } from "ui/userprofile/ChangeRegistration";
import { ProductGrid } from "ui/userprofile/Products";
import { ChangePassword } from "ui/userprofile/ChangePassword";
import { Loading } from "ui/Loading";
import {
	addProductToProfileApi,
	deleteProductFromProfileApi,
	deleteSmsProductFromProfileApi,
	getProductsByBuyerApi,
	getProfileSmsProductsApi,
} from "api/product";
import CustomStepper from "ui/CustomStepper";
import { useNavigate } from "react-router";
import { PageTypePath } from "utils/pages";
import CustomButton from "ui/Button";
import { COLOR, ICON_NAMES } from "utils/constant";
import CustomDropDownList from "ui/dropDown";
import { getProductsByPreservationFilterApi } from "api/common";
import { CustomCheckbox } from "ui/Input";
import { useWindowWidth } from "hooks/hooks";
import "./styles.css";

enum UserProfileSettingTabs {
	Information = "UserInformation",
	Notification = "Notifications",
	ChangeRegistration = "ChangeRegistration",
	UserProducts = "UserProducts",
	Password = "Password",
}

const settingsTabs = Object.values(UserProfileSettingTabs);

export const UserProfileSetting = () => {
	const [user, setUser] = React.useState<UserProfile | null>(null);
	const [countryCodes, setCountryCodes] = React.useState<
		InternationalCountryCode[]
	>([]);
	const [selectedTab, setSelectedTab] = React.useState<UserProfileSettingTabs>(
		UserProfileSettingTabs.Information,
	);
	const [Vessels, setVessels] = React.useState<IUserProfileVessel[]>([]);
	const [smsProducts, setSmsProducts] = React.useState<IProduct[]>([]);
	const [buyerProducts, setBuyerProducts] = React.useState<Product[]>([]);

	const [allProducts, setAllProducts] = React.useState<Product[]>([]);
	const [updateSmsProducts, setUpdateSmsProducts] = React.useState(false);

	const [showFresh, setShowFresh] = React.useState(true);
	const [showFrozen, setShowFrozen] = React.useState(true);
	const [showFilet, setShowFilet] = React.useState(true);


	//const [availableProducts, setAvailableProducts] = React.useState<Product[]>(
	//	[],
	//);
	const [loadingUser, setLoadingUser] = React.useState(true);
	const [tabs, setTabs] = React.useState(settingsTabs);

	const [selectedProduct, setSelectedProduct] = React.useState<Product | null>(null);

	//const [allProductsFilter, setAllProductsFilter] = React.useState({
	//	take: 3000,
	//	skip: 0,
	//	text: "", // Added text property
	//});

	const [step, setStep] = useState(0);
	const navigate = useNavigate();

	useEffect(() => {
		if (!user) {
			getUserProfileApi()
				.then((response) => {
					setUser(response.data);
					setLoadingUser(false);
				})
				.catch((error) => {
					console.log(error);
				})
				.finally(() => {
					setLoadingUser(false);
				});
		}

		getGetInternationalCountryCodeApi()
			.then((response) => {
				setCountryCodes(response);
			})
			.catch((error) => {
				console.log(error);
			});
		if (
			user?.userGroup &&
			user.userGroup.filter(
				(role) => role.vessel || role.buyer || role.terminal,
			).length > 0
		) {
			getUserVesselsApi()
				.then((response) => {
					setVessels(response.data);
				})
				.catch((error) => {
					console.log(error);
				});
			getProfileSmsProductsApi()
				.then((response) => {
					setSmsProducts(response.data);
				})
				.catch((error) => {
					console.log(error);
				});
		}

		handleTabs();
	}, [user]);

	//useEffect(() => {
	//	if (
	//		user?.userGroup &&
	//		user.userGroup.filter(
	//			(role) => role.vessel || role.buyer || role.terminal,
	//		).length > 0
	//	) {
	//		//getAllProducts();
	//	}
	//}, [allProductsFilter, user?.userGroup]);

	useEffect(() => {
		if (
			user?.userGroup &&
			user.userGroup.filter(
				(role) => role.vessel || role.buyer || role.terminal,
			).length > 0
		) {
			getBuyerProducts();
		}
	}, [user?.userGroup]);

	//useEffect(() => {
	//	if (allProducts.length > 0) {
	//		const filtered = allProducts.filter(
	//			(product) => !buyerProducts.some((buyer) => buyer.id === product.id),
	//		);
	//		setAvailableProducts(filtered);
	//	} else {
	//		setAvailableProducts([]);
	//	}
	//}, [allProducts, buyerProducts]);

	const handleDeleteProduct = (id: number) => {
		deleteSmsProductFromProfileApi(id as any)
			.then(() => {
				getProfileSmsProductsApi()
					.then((response) => {
						setSmsProducts(response.data);
					})
					.catch((error) => {
						console.log(error);
					});
			})
			.catch((error) => {
				console.error("Error deleting product:", error);
			});
	};

	const handleTabs = () => {
		const _tabs = settingsTabs.filter((tab) => {
			if (tab === UserProfileSettingTabs.ChangeRegistration) {
				return (
					user?.userGroup &&
					user.userGroup.filter((role) => role.vessel).length > 0
				);
			}
			if (tab === UserProfileSettingTabs.UserProducts) {
				return (
					user?.userGroup &&
					user.userGroup.filter(
						(role) => role.vessel || role.buyer || role.terminal,
					).length > 0
				);
			}
			if (tab === UserProfileSettingTabs.Notification) {
				return (
					user?.userGroup &&
					user.userGroup.filter((role) => role.vessel || role.buyer).length > 0
				);
			}
			return true;
		});
		setTabs(_tabs);
	};

	const handleAddProductToBuyer = (product: Product) => {
		addProductToProfileApi(product.id as any)
			.then(() => {
				getBuyerProducts();
			})
			.catch((error) => {
				console.log(error);
			});
	};
	const handleDeleteBuyerProduct = (data: Product) => {
		deleteProductFromProfileApi(data.id as any)
			.then(() => {
				getBuyerProducts();
			})
			.catch((error) => {
				console.log(error);
			});
	};

	const getBuyerProducts = () => {
		getProductsByBuyerApi()
			.then((response) => {
				setBuyerProducts(response.data);
			})
			.catch((error) => {
				console.log(error);
			});
	};

	const handleStepTabs = (step: number) => {
		const tab = tabs[step];
		setSelectedTab(tab);
		setStep(step);
	};

	const handleNextStep = () => {
		if (step < tabs.length - 1) {
			handleStepTabs(step + 1);
			return;
		}

		navigate(`/`);
	};

	const handlePreviousStep = () => {
		if (step > 0) {
			handleStepTabs(step - 1);
		}
	};

	const setSpeciesFilter = (speciesCode: string) => {
	}

	const isFirstStep = step === 0;
	const isLastStep = step === tabs.length - 1;

	const addSmsProductFromProfile = () => {
		if (selectedProduct === null)
			return;

		addProductToProfileApi(selectedProduct.id as any)
			.then(() => {
				setSelectedProduct(null);
				getBuyerProducts();
			})
			.catch((error) => {
				console.log(error);
			});
	};

	const windowWidth = useWindowWidth();
	const isMobileView = windowWidth < 768;

	if (loadingUser) return <Loading />;
	return (
		<div
			className={`${styles.PageContainer} user-profile-setting-page`}
			style={{
				maxHeight: isMobileView ? "none" : "85%",
				height: isMobileView ? "auto" : "calc(100dvh - 110px)",
				display: "flex",
				flexDirection: "column",
				justifyContent: "space-between",
			}}
		>
			<div style={{ minWidth: 0, maxHeight: isMobileView ? "none" : "90%" }}>
				<div
					className="page-header"
					// style={{ borderBottom: "1px solid #dee2e6" }}
				>
					<legend className={styles.BoxHeadingLarge}>{t("UserProfile")}</legend>
				</div>
				<div className="user-profile-setting-content" style={{ marginTop: "20px" }}>
					<CustomStepper
						className="user-profile-setting-stepper"
						steps={tabs.map((tab) => ({
							label: t(tab),
							optional: false,
						}))}
						activeStep={step}
						setActiveStep={handleStepTabs}
					/>

					<div className="user-profile-setting-panel" style={{
						//padding: "20px",
						paddingTop: "20px"
					}}>
						{selectedTab === UserProfileSettingTabs.Information && user && (
							<UserInformation
								user={user as any}
								setUser={setUser}
								countryCodes={countryCodes.map(
									(code) => code.internationalDialing,
								)}
								setCountryCode={() => {}}
							/>
						)}
						{selectedTab === UserProfileSettingTabs.Notification && (
							<>
								<div
									style={{
										fontWeight: "bold",
										fontSize: isMobileView ? "16px" : "18px",
										marginBottom: "10px",
										textAlign: "center",
									}}
								>
									{t("Notifications")}
								</div>
								<NotificationPage data={user?.notifications || []} />
							</>
						)}
						{selectedTab === UserProfileSettingTabs.ChangeRegistration && (
							<div>
								<div style={{ marginBottom: "10px", textAlign: "center" }}>
									<ChangeRegistration
										vessel={Vessels}
										products={smsProducts}
										setSmsProducts={setSmsProducts}
										countryCodes={countryCodes}
										deleteProduct={handleDeleteProduct}
									/>
								</div>
							</div>
						)}
						{selectedTab === UserProfileSettingTabs.UserProducts && (
							<div
								className="user-profile-setting-products-panel"
								style={{
									//display: "flex",
									//gap: "25px",
									width: "100%",
									height: isMobileView ? "auto" : "100%",
									overflow: isMobileView ? "visible" : "auto",
								}}
							>
								<div>
									<div className="user-profile-setting-products-toolbar" style={{
										display: "flex",
										flexDirection: isMobileView ? "column" : windowWidth >= 1600 ? "row" : "column",
										alignItems: isMobileView ? "stretch" : windowWidth >= 1600 ? "center" : "flex-start",
										gap: "20px",
									}}>
										<div className="user-profile-setting-products-filters" style={{
											display: "flex",
											flexDirection: windowWidth >= 768 ? "row" : "column",
											gap: "20px",
											width: "100%",
										}}>
											<CustomCheckbox
												value={showFresh}
												onChange={(value) =>
													setShowFresh(value)
												}
												label={t("FreshFilter")}
												containerStyle={{ flex: windowWidth >= 768 ? 1 : undefined, width: windowWidth >= 768 ? undefined : "100%", justifyContent: "space-between" }}
											/>
											<CustomCheckbox
												value={showFrozen}
												onChange={(value) =>
													setShowFrozen(value)
												}
												label={t("FrozenFilter")}
												containerStyle={{ flex: windowWidth >= 768 ? 1 : undefined, width: windowWidth >= 768 ? undefined : "100%", justifyContent: "space-between" }}
											/>
											<CustomCheckbox
												value={showFilet}
												onChange={(value) =>
													setShowFilet(value)
												}
												label={t("FiletFilter")}
												containerStyle={{ flex: windowWidth >= 768 ? 1 : undefined, width: windowWidth >= 768 ? undefined : "100%", justifyContent: "space-between" }}
											/>
										</div>
										<div className="" style={{
											display: "flex",
											flexDirection: windowWidth >= 768 ? "row" : "column",
											alignItems: windowWidth >= 768 ? "center" : "flex-start",
											gap: "20px",
											width: "100%",
										}}>
											<CustomDropDownList
												className="user-profile-setting-select-field"
												name="ProductDropDown"
												data={[]}
												value={selectedProduct}
												onSelect={(data) => {
													setSelectedProduct(data);
												}}
												serverFilterApi={(text) => getProductsByPreservationFilterApi(text, showFresh, showFrozen, showFilet)}
												// label={t("Product")}
												defaultItem={{ id: null, name: "Velg Vare" }}
												filterable={true}
												serverFilter={true}
												textField={"name"}
												dataItemKey={"id"}
											/>
											<CustomButton
												label={t("AddProduct")}
												bgColor={COLOR.Green}
												disabled={!selectedProduct}
												color="white"
												onClick={addSmsProductFromProfile}
												btnStyle={{ width: windowWidth >= 768 ? "25%" : "100%" }}
											/>
										</div>
									</div>


									<div>&nbsp;</div>
									<div className="user-profile-setting-grid-shell">
										<ProductGrid
											data={buyerProducts}
											btnIconName={ICON_NAMES.Delete}
											headerText={t("YourProducts")}
											btnClick={handleDeleteBuyerProduct}
											showAllProducts={false}
											hideVirtualScroll={true}
											isMobileView={isMobileView}
										/>
									</div>
								</div>
							</div>
						)}
						{selectedTab === UserProfileSettingTabs.Password && (
							<div>
								<ChangePassword />
							</div>
						)}
					</div>
				</div>
			</div>
			<div
				className="user-profile-setting-actions-row"
				style={{
					display: "flex",
					justifyContent: "space-between",
					flexDirection: isMobileView ? "column" : "row",
					gap: isMobileView ? "12px" : "0px",
					padding: "0px",
					marginBottom: 0,
					backgroundColor: "#fff",
				}}
			>
				<CustomButton
					label={t("Previous")}
					onClick={handlePreviousStep}
					disabled={isFirstStep}
					bgColor={isFirstStep ? "#ccc" : undefined}
					btnStyle={isMobileView ? { width: "100%" } : undefined}
				/>
				<CustomButton
					label={isLastStep ? t("Complete") : t("Next")}
					onClick={handleNextStep}
					// disabled={isLastStep}
					labelStyle={{
						color: "white",
					}}
					bgColor={COLOR.Green}
					btnStyle={isMobileView ? { width: "100%" } : undefined}
				/>
			</div>
		</div>
	);
};
